<template>
  <footer class="foota">
    <div class="footer-inner responsive-pad">
      <img v-if="!is_loggedIn" class="footer-brand"
        src="~@/assets/images/lg-gobran-footer-1-1.png" alt="Gobran">
      <div v-if="footerText" class="footer-content" v-html="footerText"></div>
      <p v-else class="footer-caption">Vertretungsplanung</p>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    is_loggedIn() {
      return this.$store.getters['User/is_loggedin'];
    },
    footerText() {
      const user = this.$store.getters['User/user'];
      return this.is_loggedIn && user && user.client_id ? user.client_id.footer_txt : '';
    },
  },
};
</script>

<style lang="scss">
.foota {
  width: 100%;
  margin-top: 32px;
  border-top: 1px solid var(--theme-border);
  background: var(--theme-wash);
  color: var(--theme-text);
  font-family: var(--app-font-family);
  font-size: .75rem;
  line-height: 1.6;

  .footer-inner {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px 24px;
    padding-top: 18px;
    padding-bottom: 18px;
  }
  .footer-brand { width: auto; height: 24px; object-fit: contain; }
  .footer-content { min-width: 0; overflow-wrap: anywhere; }
  .footer-caption { margin: 0; font-weight: 500; }
  .footer-content p { color: inherit; font-size: inherit; }
  .footer-content p:last-child { margin-bottom: 0; }
  a {
    color: var(--theme-text);
    text-decoration: underline;
    text-underline-offset: 3px;
    &:hover { color: var(--theme-hover); }
    &:focus-visible { outline: 2px solid var(--theme-accent); outline-offset: 3px; }
  }
}
@media (max-width: 600px) {
  .foota .footer-inner { align-items: flex-start; flex-direction: column; gap: 12px; }
}
</style>
